
interface AreaHeroProps {
  data: {
    name: string;
    region: string;
    description: string;
    heroImage: string;
    serviceAreas: string[];
  };
}

export default function AreaHero({ data }: AreaHeroProps) {
  return (
    <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={data.heroImage}
          alt={`Painting services in ${data.name}`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Painting Services in {data.name}
        </h1>
        <p className="text-xl md:text-2xl mb-4 font-medium">
          {data.region}
        </p>
        <p className="text-lg md:text-xl leading-relaxed mb-8 max-w-3xl mx-auto">
          {data.description}
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {data.serviceAreas.map((area, index) => (
            <span
              key={index}
              className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium"
            >
              {area}
            </span>
          ))}
        </div>
        <a
          href="/booking"
          className="inline-block px-8 py-4 bg-sky-500 hover:bg-sky-600 text-white font-bold rounded-lg transition-colors duration-300 whitespace-nowrap"
        >
          Get a Free Quote
        </a>
      </div>
    </section>
  );
}
